import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=05368970"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projects\\laravel\\kepio-theme\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05368970')) {
      api.createRecord('05368970', component.options)
    } else {
      api.reload('05368970', component.options)
    }
    module.hot.accept("./AudioPlayer.vue?vue&type=template&id=05368970", function () {
      api.rerender('05368970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/homepage/AudioPlayer.vue"
export default component.exports